'use client'

import useSWR from 'swr'
import { Card, CardContent } from '@/components/ui/card'
import apiService from '@/app/services/apiService'
import { useState } from 'react'
import DateRangePicker from './DateRangePicker'

export default function ContractsSalesSummaryCard() {
  const [query, setQuery] = useState('')
  const { data, error, isLoading } = useSWR(
    '/api/contracts/summary/',
    (url) => apiService.getWithToken(url)
  )

  const handleDateChange = (start: string, end: string) => {
    setQuery(`?start=${start}&end=${end}`)
  }

  if (isLoading) return <p>Carregando vendas de contratos...</p>
  if (error) return <p className="text-red-500">Erro ao carregar vendas.</p>
  if (!data) return null

  return (
    <Card>
      <CardContent className="p-4">
        <h2 className="text-lg font-semibold mb-2">Resumo de Vendas (Contratos)</h2>
        <div className="max-w-md w-full p-4 bg-white rounded-2xl shadow">
          <DateRangePicker onChange={handleDateChange} />
        </div>
        <div className="flex justify-between text-sm">
          <span>Contratos pagos:</span>
          <span>{data.total_contracts}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span>Faturamento bruto:</span>
          <span>R$ {parseFloat(data.total_gross).toFixed(2)}</span>
        </div>
      </CardContent>
    </Card>
  )
}
